/* ============================================================
   Atelier d'Imagen — Front-end interactions
   Vanilla JS, no dependencies. Self-initializes on DOMContentLoaded.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Announcement bar rotation ---------- */
  function initAnnounceBar() {
    document.querySelectorAll('.atd-announce').forEach(function (bar) {
      var msgs = bar.querySelectorAll('.atd-announce__msg');
      if (msgs.length < 2) return;
      var i = 0;
      msgs[0].classList.add('is-active');
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, 5000);
    });
  }

  /* ---------- Quick-add to cart ---------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-atd-quickadd]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      btn.setAttribute('disabled', 'true');
      var originalText = btn.textContent;
      btn.textContent = 'Añadiendo...';

      fetch(window.Shopify ? '/cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Añadido ✓';
          window.dispatchEvent(new CustomEvent('atd:cart-updated'));
          setTimeout(function () {
            btn.textContent = originalText;
            btn.removeAttribute('disabled');
          }, 1600);
        })
        .catch(function () {
          btn.textContent = 'Error';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.removeAttribute('disabled');
          }, 1600);
        });
    });
  }

  /* ---------- Cart count refresh ---------- */
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-atd-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        });
      })
      .catch(function () { /* silent */ });
  }

  /* ---------- Scroll reveal (IntersectionObserver) ---------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-atd-reveal]');
    if (!els.length || !window.IntersectionObserver) {
      els.forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -36px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---------- Account tab switching ---------- */
  function initAccountTabs() {
    var nav = document.querySelector('.atd-acct__nav');
    if (!nav) return;
    var links = nav.querySelectorAll('a[data-tab]');
    var panels = document.querySelectorAll('.atd-acct__panel[data-panel]');
    if (!links.length || !panels.length) return;

    panels.forEach(function (p) {
      p.classList.remove('atd-acct__panel--fallback');
      p.classList.remove('is-active');
    });
    links.forEach(function (l) { l.classList.remove('is-active'); });

    function activate(tabId) {
      panels.forEach(function (p) { p.classList.remove('is-active'); });
      links.forEach(function (l) { l.classList.remove('is-active'); });
      var target = document.querySelector('.atd-acct__panel[data-panel="' + tabId + '"]');
      var activeLink = nav.querySelector('a[data-tab="' + tabId + '"]');
      if (target) target.classList.add('is-active');
      if (activeLink) {
        activeLink.classList.add('is-active');
        if (activeLink.scrollIntoView) {
          activeLink.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
      history.replaceState(null, '', '#' + tabId);
    }

    var hash = window.location.hash.replace('#', '');
    var validPanel = document.querySelector('.atd-acct__panel[data-panel="' + hash + '"]');
    activate(validPanel ? hash : links[0].dataset.tab);

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        activate(this.dataset.tab);
      });
    });
  }

  /* ---------- Account address edit forms ---------- */
  function initAddressEdits() {
    document.querySelectorAll('[data-edit-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = this.dataset.editTrigger;
        var form = document.getElementById('atd-edit-' + id);
        if (!form) return;
        form.classList.toggle('is-open');
        if (form.classList.contains('is-open')) {
          form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
    document.querySelectorAll('[data-edit-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = document.getElementById('atd-edit-' + this.dataset.editClose);
        if (form) form.classList.remove('is-open');
      });
    });
  }

  /* ---------- Recover password toggle ---------- */
  function initRecoverToggle() {
    var trigger = document.getElementById('atd-recover-toggle');
    var panel = document.getElementById('atd-recover');
    if (!trigger || !panel) return;
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      panel.classList.toggle('is-open');
    });
  }

  /* ---------- Init ---------- */
  function init() {
    initAnnounceBar();
    initQuickAdd();
    refreshCartCount();
    initReveal();
    initAccountTabs();
    initAddressEdits();
    initRecoverToggle();
    window.addEventListener('atd:cart-updated', refreshCartCount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
